import { MarketingApproach } from '@betterfunnel/types';
import {
  AcademicCapIcon,
  BookOpenIcon,
  ChevronRightIcon,
  HeartIcon,
  QueueListIcon,
} from '@heroicons/react/20/solid';
import { classNames } from '../../utils';

interface Suggestion {
  type: MarketingApproach;
  name: string;
  description: string;
  iconColor: string;
  icon: any;
}

const items: Suggestion[] = [
  {
    type: 'emotional',
    name: 'Emotional',
    description: 'A landing page that evokes strong emotions in the audience.',
    iconColor: 'bg-pink-500',
    icon: HeartIcon,
  },
  {
    type: 'rational',
    name: 'Rational',
    description:
      'A landing page that relies on logical reasoning and facts to persuade the audience.',
    iconColor: 'bg-purple-500',
    icon: AcademicCapIcon,
  },
  {
    type: 'storytelling',
    name: 'Storytelling',
    description:
      'A landing page that tells a compelling story related to your product or service.',
    iconColor: 'bg-yellow-500',
    icon: BookOpenIcon,
  },
  {
    type: 'productFocused',
    name: 'Product Focused',
    description:
      // eslint-disable-next-line quotes
      "A landing page that heavily emphasizes the product or service's features, benefits, and value propositions.",
    iconColor: 'bg-indigo-500',
    icon: QueueListIcon,
  },
];

interface Props {
  onCreateClick: (suggestion: Suggestion) => void;
}

export default function NoVariantExists({ onCreateClick }: Props) {
  return (
    <div className="mx-auto max-w-lg">
      <h2 className="text-base font-semibold leading-6 text-gray-900">
        You don&apos;t have any variants in this dynamic page.
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        Create a new one by selecting one of our suggestions.
      </p>
      <ul
        role="list"
        className="mt-6 divide-y divide-gray-200 border-b border-t border-gray-200"
      >
        {items.map((item, itemIdx) => (
          <li key={itemIdx as any}>
            <div className="group relative flex items-start space-x-3 py-4">
              <div className="shrink-0">
                <span
                  className={classNames(
                    item.iconColor,
                    'inline-flex h-10 w-10 items-center justify-center rounded-lg',
                  )}
                >
                  <item.icon
                    className="h-6 w-6 text-white"
                    aria-hidden="true"
                  />
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-gray-900">
                  <button onClick={() => onCreateClick(item)}>
                    <span className="absolute inset-0" aria-hidden="true" />
                    {item.name}
                  </button>
                </div>
                <p className="text-sm text-gray-500">{item.description}</p>
              </div>
              <div className="shrink-0 self-center">
                <ChevronRightIcon
                  className="h-5 w-5 text-gray-400 group-hover:text-gray-500"
                  aria-hidden="true"
                />
              </div>
            </div>
          </li>
        ))}
      </ul>
      {/* <div className="mt-6 flex">
        <a
          href="#"
          className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
        >
          Or start from an empty project
          <span aria-hidden="true"> &rarr;</span>
        </a>
      </div> */}
    </div>
  );
}
